export default [
  {
    popular: false,
    title: "Free",
    description: "Essential features and CDN",
    price: {
      monthly: 0,
      annual: 0,
    },
    storage: "0.5 GB storage",
    buttonLink: "https://my.sirv.com/#/signup",
    buttonText: "Get started",
    featuresTitle: "What you get with free:",
    features: [
      { title: "Media galleries" },
      { title: "360 spin" },
      { title: "Image zoom" },
      { title: "Serve video streams" },
      { title: "Dynamic imaging" },
      { title: "CDN for rapid delivery" },
      { title: "FTP, S3 and API access" },
      { title: "Sirv branding on spins/zooms" },
      { title: "Basic email support" },
      { title: "3 users" },
    ],
  },
  {
    popular: true,
    title: "Business",
    description: "Complete features, large allowances, no branding",
    price: {
      monthly: 19,
      annual: 17,
    },
    priceLabelSum: 25,
    priceLabel: "if paid monthly",
    labels: [5, 12, 20, 40, 60, 100, 200, 350, 500],
    inputSlider: 20,
    storage: {
      "5 GB storage": {
        monthly: 19,
        annual: 17.42,
        "Data transfer limit": 20,
      },
      "12 GB storage": {
        monthly: 39,
        annual: 35.75,
        "Data transfer limit": 48,
      },
      "20 GB storage": {
        monthly: 59,
        annual: 54.07,
        "Data transfer limit": 80,
      },
      "40 GB storage": {
        monthly: 89,
        annual: 81.57,
        "Data transfer limit": 160,
      },
      "60 GB storage": {
        monthly: 119,
        annual: 109.07,
        "Data transfer limit": 240,
      },
      "100 GB storage": {
        monthly: 199,
        annual: 182.41,
        "Data transfer limit": 400,
      },
      "200 GB storage": {
        monthly: 359,
        annual: 329.07,
        "Data transfer limit": 800,
      },
      "350 GB storage": {
        monthly: 599,
        annual: 549.08,
        "Data transfer limit": 1400,
      },
      "500 GB storage": {
        monthly: 849,
        annual: 778.25,
        "Data transfer limit": 2000,
      },
    },
    helpLink: "#",
    helpText: "How much storage do you need?",
    buttonLink: "https://my.sirv.com/#/signup",
    buttonText: "Start free a 30-day trial",
    featuresTitle: "Everything in Free, plus:",
    features: [
      { title: "Serve 3D models" },
      { title: "Serve other filetypes" },
      { title: "Workflow automations" },
      { title: "Smart gallery" },
      { title: "Image hotspots" },
      { title: "Video to spin conversion" },
      { title: "Use your own domain" },
      { title: "No Sirv branding" },
      { title: "Priority email support" },
      { title: "20 users" },
    ],
  },
  {
    popular: false,
    title: "Enterprise",
    description: "Tailored solution for your unique needs",
    price: {
      monthly: 999,
      annual: 999,
    },
    storage: "Storage from 300 GB",
    helpLink: "#",
    helpText: "How much storage do you need?",
    buttonLink: "/contact/",
    buttonText: "Contact Us",
    link: "/enterprise/",
    linkText: "Learn more",
    featuresTitle: "Everything in Business, plus:",
    features: [
      { title: "Configurable plans" },
      { title: "Custom automations" },
      { title: "Folder and user controls" },
      { title: "Off-site backup" },
      { title: "Automatic failover" },
      { title: "Onboarding program" },
      { title: "Dedicated success manager" },
      { title: "99.999% guaranteed uptime SLA" },
      { title: "Priority email & phone support" },
      { title: "50+ users" },
    ],
  },
];
